import { formatCredits } from "../constants/credits";

/** @param {unknown} value */
const count = (value) => typeof value === "number" && Number.isSafeInteger(value) && value >= 0;

/** Financial proof must come from the exact purchase attempt, not an older job. */
/** @param {any} settlement */
export const paidMediaSettlementKnown = (settlement) =>
  !!settlement &&
  count(settlement.charged_credits) &&
  count(settlement.refunded_credits) &&
  settlement.refunded_credits <= settlement.charged_credits &&
  count(settlement.free_redos_used) &&
  count(settlement.free_redos_restored) &&
  settlement.free_redos_restored <= settlement.free_redos_used;

/** @param {any} settlement */
export const paidMediaSettlementMessage = (settlement) => {
  if (!paidMediaSettlementKnown(settlement))
    return "Refund and free-redo details are not available yet.";
  const messages = [];
  if (settlement.refunded_credits > 0)
    messages.push(`${formatCredits(settlement.refunded_credits)} returned.`);
  if (settlement.free_redos_restored > 0)
    messages.push(
      `${settlement.free_redos_restored} free redo${settlement.free_redos_restored === 1 ? "" : "s"} restored.`
    );
  return messages.join(" ");
};
